import React from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

// Clickable column header that drives a { key, dir } sort state.
export function SortTH({ label, k, sort, setSort, className = "", align = "left" }) {
  const active = sort.key === k;
  const Icon = !active ? ChevronsUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  const toggle = () =>
    setSort((s) => (s.key === k ? { key: k, dir: s.dir === "asc" ? "desc" : "asc" } : { key: k, dir: "asc" }));
  return (
    <th className={className}>
      <button
        type="button"
        onClick={toggle}
        data-testid={`sort-${k}`}
        className={`inline-flex items-center gap-1 hover:text-ink-1 transition-colors ${align === "right" ? "flex-row-reverse" : ""} ${active ? "text-ink-1" : ""}`}
      >
        {label} <Icon size={11} className={active ? "opacity-90" : "opacity-40"} />
      </button>
    </th>
  );
}

// Sort a list by the accessor registered for the active key. Numbers compare
// numerically; everything else compares as natural-order strings.
export function applySort(arr, sort, accessors) {
  if (!sort.key || !accessors[sort.key]) return arr;
  const acc = accessors[sort.key];
  const sorted = [...arr].sort((a, b) => {
    const va = acc(a);
    const vb = acc(b);
    if (typeof va === "number" && typeof vb === "number") return va - vb;
    return String(va ?? "").localeCompare(String(vb ?? ""), undefined, { numeric: true, sensitivity: "base" });
  });
  return sort.dir === "asc" ? sorted : sorted.reverse();
}
